import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import { decodeStorage } from 'functions/storageBase64';
import { dateFormat } from 'functions/dateFormat'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import { getPaperless, postPaperless } from 'services/Paperless'

export const useAcountStatus = (props) => {
    const {
        setPeriod,
        errorCode
    } = props

    // funciones para mostrar el modal
    const [showModal, SetShowModal] = useState(false);
    const showModalErrorCode = () => SetShowModal(true);
    const lastConsultData =  decodeStorage('lastConsultData')
    
    const handleClose = () => SetShowModal(false)

    useEffect(()=>{
        if(errorCode <= 499){
            showModalErrorCode()
        }
    },[errorCode])

    const cardending = decodeStorage('cardending')
    const nombreTitularStore = decodeStorage('nombreTitular')

    const fAct = new Date()
    const meses = ['01','02','03','04','05','06','07','08','09','10','11','12']
    const mesesPrev1 = ['12', '01','02','03','04','05','06','07','08','09','10','11']
    const mesesPrev2 = ['11','12','01','02','03','04','05','06','07','08','09','10']

    let anio = fAct.getUTCFullYear()
    let lastAnio, lastAnio2

    if(mesesPrev1[fAct.getMonth()] === "12"){
        lastAnio = fAct.getUTCFullYear() -1
    }else{
        lastAnio = fAct.getUTCFullYear()
    }

    if(mesesPrev2[fAct.getMonth()] === "11" || mesesPrev2[fAct.getMonth()] === "12" ){
        lastAnio2 = fAct.getUTCFullYear() - 1
    }else{
        lastAnio2 = fAct.getUTCFullYear()
    }

    const FA0 = meses[fAct.getMonth()]+'/'+anio
    const FA1 = mesesPrev1[fAct.getMonth()]+'/'+lastAnio
    const FA2 = mesesPrev2[fAct.getMonth()]+'/'+lastAnio2

    let numeroTarjeta = `** ****** *${cardending}`;
    let nombreTitular = nombreTitularStore;


    const [billDate, setBillDate] = useState("01-Ene-21")
    //console.log('lastConsultData: ',lastConsultData)
    useEffect(()=>{
        if(lastConsultData[0]?.payday_limit !== 0){
            setBillDate( dateFormat(lastConsultData[0]?.payday_limit) )
        }
    },[])


    const fechas = [
        { "id": 0, "fecha": FA1 },
        { "id": 1, "fecha": FA2 }
    ]

    const [buttonActive, setButtonActive] = useState(false);

    const [optDate, setOptDate] = useState(false);
    const handleSeleccionarFecha = (e) => {
        setOptDate(e.target.value)
        if(e.target.value){
            setOpcionSeleccionada(2)
            if(opcionSeleccionada === 2){
                setButtonActive(1)
            }
        }
    }

    // selecciona opcion en el radio button
    const [opcionSeleccionada, setOpcionSeleccionada] = useState(false);
    const handleSeleccionarOpcion = (e) => {
        let opc = Number(e.target.value);
        setOpcionSeleccionada(opc);

        if(opc === 1){
            setButtonActive(1)
            setOptDate(false)
            document.querySelector('[name="selectDate"]').selectedIndex = '0'
        }
        else if(opc === 2){
            if(optDate){
                setButtonActive(1)
            }
            else{
                setButtonActive(false)
            }
        }else{
            setButtonActive(false)
        }
    };


    // descarga estado cuenta, muesta alert de descarga
    const handleConsultar = () => {
        //console.log('opcionSeleccionada: ',opcionSeleccionada)
        if(opcionSeleccionada === 1){
            setPeriod({'mes': FA0.split('/')[0], "anio": FA0.split('/')[1]})
            //console.log(`click seleccionado periodo: {'mes': ${FA0.split('/')[0]}, "anio": ${FA0.split('/')[1]} }`)
        }
        else if(opcionSeleccionada === 2){
            setPeriod({'mes': optDate.split('/')[0], "anio": optDate.split('/')[1]})
            //console.log(`click seleccionado falta periodo: {'mes': ${optDate.split('/')[0]}, "anio": ${optDate.split('/')[1]} }`)
        }
        else{
            //console.log('click sin seleccionar')
        }
    };

    const acountStatusData = {
        opcionSeleccionada,
        fechas,
        billDate,
        errorCode,
        buttonActive,
        showModal,
        numeroTarjeta,
        nombreTitular
    }

    return{
        acountStatusData,
        handleSeleccionarOpcion,
        handleSeleccionarFecha,
        handleConsultar,
        handleClose,
    }
}



export const useDigitalAcount = () => {
    const history = useHistory();
    const lastConsultData = decodeStorage('lastConsultData')
    const correo = decodeStorage('email')
    const [flagTieneEstadoCuentaDigital, setFlagTieneEstadoCuentaDigital] = useState(false)
    const [statePaper, setStatePeper] = useState()
    let fecha = new Date

    useEffect(()=>{
        getPaperless(lastConsultData[0]?.cards[0].card_number)
        .then(setStatePeper)
    },[])

    const [isDigital, setIsDigital] = useState("digital")
    useEffect(()=>{
        if(statePaper?.statusCode === 200){
            if(statePaper.data.resultado){
                if( Number(statePaper.data.resultado.split('|')[0] ) === 2  ||  Number(statePaper.data.resultado.split('|')[0] ) === 3  ){
                    console.log('statePaper:', statePaper.data.resultado.split('|')[0])
                    setFlagTieneEstadoCuentaDigital(true)
                    setIsDigital("digital")
                }else{
                    console.log('statePaper:', statePaper.data.resultado.split('|')[0])
                }
            }
        }
    },[statePaper])

    const [baja, setBaja] = useState(false)
    useEffect(()=>{
        if(baja){
            postPaperless({
                cardnumber: lastConsultData[0]?.cards[0].card_number,
                date: fecha.toLocaleDateString(),
                option: "01",
                autorization: "1",
                email: correo,
                applicative: "02"
            })
            .then()
            setIsDigital("impreso")
            setFlagTieneEstadoCuentaDigital(false)
            setBaja(false)
        }
    },[baja])


    const [update, setUpdate] = useState(false)
    const [selectOption, setSelectOption] = useState()
    useEffect(()=>{
        if(selectOption){
            setUpdate(true)
        }
    },[selectOption])

    useEffect(()=>{
        if(update){
            postPaperless({
                cardnumber: lastConsultData[0]?.cards[0].card_number,
                date: fecha.toLocaleDateString(),
                option: String(selectOption),
                autorization: "1",
                email: correo,
                applicative: "02"
            })
            .then()
            if(String(selectOption) !== "01"){
                setFlagTieneEstadoCuentaDigital(true)
                setSelectOption()
                setUpdate(false)
                setIsDigital("digital")
            }else{
                setFlagTieneEstadoCuentaDigital(true)
                setSelectOption()
                setUpdate(false)
                setIsDigital("impreso")
            }
        }
    },[update])


    // redirecciona a seccion de permisos para estado de cuenta digital
    const handleSolicitarEstadoDigital = (value) => {
        let opcion = value
        setSelectOption( String(opcion) )
    };

    //dar debaja correo
    const handleDarDeBaja = () => {
        setBaja(true)
    };

    const  acountstatusDigital = {
        correo,
        flagTieneEstadoCuentaDigital
    }

    const textSuccess = {
        estado: isDigital
    }

    return{
        acountstatusDigital,
        textSuccess,
        handleDarDeBaja,
        handleSolicitarEstadoDigital
    }
}